import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import { selectTaskStatus, fetchStatus } from '../../../../slices/taskStatus'
import { selectTaskType, fetchTypes } from '../../../../slices/taskType'
import {
  selectTaskPriority,
  fetchPriorities
} from '../../../../slices/priority'
import { selectCategory, fetchCategories } from '../../../../slices/category'

const useTableDependencies = () => {
  const dispatch = useAppDispatch()

  const { loaded: statusLoaded, loading: statusLoading } =
    useAppSelector(selectTaskStatus)
  const { loaded: typeLoaded, loading: typeLoading } =
    useAppSelector(selectTaskType)
  const { loaded: prioritiesLoaded, loading: prioritiesLoading } =
    useAppSelector(selectTaskPriority)
  const { loaded: categoriesLoaded, loading: categoriesLoading } =
    useAppSelector(selectCategory)

  // Load statuses
  React.useEffect(() => {
    if (!statusLoaded && !statusLoading) {
      dispatch(fetchStatus())
    }
  }, [statusLoaded, statusLoading, dispatch])

  // Load types
  React.useEffect(() => {
    if (!typeLoaded && !typeLoading) {
      dispatch(fetchTypes())
    }
  }, [typeLoaded, typeLoading, dispatch])

  // Load priorities
  React.useEffect(() => {
    if (!prioritiesLoaded && !prioritiesLoading) {
      dispatch(fetchPriorities())
    }
  }, [prioritiesLoaded, prioritiesLoading, dispatch])

  // Load categories
  React.useEffect(() => {
    if (!categoriesLoaded && !categoriesLoading) {
      dispatch(fetchCategories())
    }
  }, [categoriesLoaded, categoriesLoading, dispatch])
}

export default useTableDependencies
